import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { useTranslation } from "@/hooks/useTranslation";
import {
  UserHistoryCompaniesExport,
  UserHistoryDTO,
  UserHistoryTargetListingAddCompanies,
  UserHistoryTargetSaveCompanyFromTag,
} from "@shaarp/common";
import { NavLink } from "react-router-dom";

export default function DataTableCellUsersHistoryTarget({
  userHistory,
}: {
  userHistory: UserHistoryDTO;
}) {
  const { t } = useTranslation();

  switch (userHistory.action) {
    case "LISTING_ADD_COMPANIES":
      const listingData =
        userHistory.data as UserHistoryTargetListingAddCompanies;
      const companiesCount = listingData.companiesIds?.length;
      if (companiesCount === undefined) {
        return `Ajout de ${t("components.dataTableUsersHistory.target.unknownCount")} entreprises à une liste`;
      }
      return companiesCount === 1
        ? t("components.dataTableUsersHistory.target.addCompanies_one", {
            count: companiesCount,
          })
        : t("components.dataTableUsersHistory.target.addCompanies", {
            count: companiesCount,
          });
    case "EXPORT_COMPANIES":
      const exportData = userHistory.data as UserHistoryCompaniesExport;
      const exportCount = exportData.companiesIds?.length;
      if (exportCount === undefined) {
        return `Export de ${t("components.dataTableUsersHistory.target.unknownCount")} entreprises au format ${exportData.format}`;
      }
      return exportCount === 1
        ? t("components.dataTableUsersHistory.target.exportCompanies_one", {
            count: exportCount,
            format: exportData.format,
          })
        : t("components.dataTableUsersHistory.target.exportCompanies", {
            count: exportCount,
            format: exportData.format,
          });
    case "SAVE_COMPANY_FROM_TAG": {
      const savedCount = (
        userHistory.data as UserHistoryTargetSaveCompanyFromTag
      ).companiesIds?.length;
      return t("components.dataTableUsersHistory.target.saveCompaniesFromTag", {
        count: savedCount ?? 0,
      });
    }
    case "PREVIEW_COMPANY":
      // A company known only from the web has no page to link to.
      if (!userHistory.metadata?.company?.id) {
        return t("components.dataTableUsersHistory.target.previewCompanyOffBase");
      }
      break;
    default:
      break;
  }

  if (!userHistory.metadata?.company || !userHistory.metadata.company.id) {
    const keys = Object.keys(userHistory.data);
    // @ts-expect-error data is a generic type
    return keys.map((key) => `${key}: ${userHistory.data[key]}`).join(" / ");
  }

  return (
    <NavLink
      to={`/company/${userHistory.metadata.company.id}`}
      className="flex items-center"
    >
      <Avatar className="w-9 h-9">
        <AvatarImage
          src={
            userHistory.metadata.company.logo ??
            userHistory.metadata.company.thumbnail
          }
          alt={userHistory.metadata.company.name}
        />
      </Avatar>
      <span className="ml-2">{userHistory.metadata.company.name}</span>
    </NavLink>
  );
}
